/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const SUCESS_MESSAGE = 'System successfully saved the information.';
export const ERROR_MESSAGE = 'There are issues in processing your request';
export const DELETE_MESSAGE = 'System successfully deleted the information.';
export const PARTICIPATE_DATE_REQ =
  'Participation dates are required for the group.';
export const ONE_EMPTY_END_DT = 'Only 1 column can have 1 empty End Date.';
export const INVALID_DATE_FORMAT =
  'Please enter a valid date in the form MM/Year or MM/DD/Year where Year is 2 or 4 digits.';
export const CONTACT_DETAILS_REQ =
  'Please add at least one Contact Information for the Plan.';
